import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import clsx from 'clsx';
import { Button, Loader } from '../../../common';
import { useTheme } from '../../../common/providers/DialectThemeProvider';
import IconButton from '../../../IconButton';
export const RightAdornment = ({ loading, currentVal, isSaved, isChanging, isVerified, onSaveCallback, onDeleteCallback, onUpdateCallback, isDeleting, deleteConfirm, }) => {
    const { icons, adornmentButton, colors } = useTheme();
    const getIcon = () => {
        if (loading) {
            return (_jsx("div", { className: clsx('dt-h-9 dt-w-9 dt-rounded-full dt-flex dt-items-center dt-justify-center dt-text-xs dt-border-0 dt-opacity-60', colors.textPrimary), children: _jsx(Loader, {}) }));
        }
        if (currentVal && !isSaved && !isChanging) {
            return (_jsx(Button, { onClick: onSaveCallback, className: clsx(adornmentButton, 'dt-w-16 dt-h-9'), children: "Submit" }));
        }
        if (isSaved && isVerified && !isDeleting && !isChanging) {
            return (_jsx(IconButton, { className: clsx('dt-w-9 dt-h-9', adornmentButton), icon: _jsx(icons.trash, {}), onClick: () => {
                    deleteConfirm(true);
                } }));
        }
        if (isSaved && isVerified && isDeleting) {
            return (_jsx(Button, { onClick: onDeleteCallback, className: clsx(adornmentButton, 'dt-w-16 dt-h-9'), children: "Delete" }));
        }
    };
    return (_jsxs(_Fragment, { children: [getIcon(), isChanging && isChanging && (_jsx(Button, { onClick: onUpdateCallback, className: clsx(adornmentButton, 'dt-w-16 dt-h-9'), children: "Submit" }))] }));
};
//# sourceMappingURL=RightAdorment.js.map